import DynamicTable from '@atlaskit/dynamic-table';
import React from 'react';
import getSalesReportBody from "./SalesReportsBody";
import getSalesReportHeader from "./SalesReportsHead"; // will remove dummy `jsonData` in API integration task
// https://ecosystem.atlassian.net/browse/AMKT-27278

import jsonData from "./vendor.json";

const SalesReports = () => {
  return /*#__PURE__*/React.createElement(DynamicTable, {
    head: getSalesReportHeader(),
    rows: getSalesReportBody(jsonData.addons),
    defaultSortKey: "number",
    defaultSortOrder: "DES"
  });
};

export default SalesReports;